import axios from "../../config/axios";

export const login = body => axios.post("users/login", body);



// WEBPACK FOOTER //
// ./src/services/requestors/login.js